(() => {
  /**
   * Initializes a Swiper instance for the announcement bar.
   * @param {HTMLElement} sectionElement - The section element containing the announcement.
   */
  const initAnnouncementSwiper = (sectionElement) => {
    if (!sectionElement || !sectionElement.classList.contains("section-announcement")) {
      return;
    }

    const swiperElement = sectionElement.querySelector(".announcement-bar--swiper");
    if (!swiperElement) {
      return;
    }

    const swiperOptions = {
      speed: Number(swiperElement.dataset.speed),
      direction: "vertical",
      spaceBetween: 8,
      autoHeight: true,
      loop: true,
      autoplay: {
        delay: Number(swiperElement.dataset.delay),
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
      },
    };

    new Swiper(swiperElement, swiperOptions);
  };

  /**
   * Observes the visibility of the announcement section and sets a CSS variable for its height.
   * @param {HTMLElement} sectionElement - The section element to observe.
   */
  const observeAnnouncementVisibility = (sectionElement) => {
    if (!sectionElement || !sectionElement.classList.contains("section-announcement")) {
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const heightProperty = window.getComputedStyle(document.documentElement).getPropertyValue('--ann-bar-height');
          let annHeight = parseFloat(heightProperty);
          annHeight = annHeight + entry.boundingClientRect.height
          document.documentElement.style.setProperty("--ann-bar-height", annHeight + "px")
        } else {
          document.documentElement.style.setProperty("--ann-bar-height", "0px");
        }
      });
    });

    observer.observe(sectionElement);
  };

  // Initialize for the current script's parent element
  const parentElement = document.currentScript.parentElement;
  initAnnouncementSwiper(parentElement);
  observeAnnouncementVisibility(parentElement);

  // Add event listener for Shopify section load events
  document.addEventListener("shopify:section:load", (event) => {
    initAnnouncementSwiper(event.target);
    observeAnnouncementVisibility(event.target);
  });
})();
